import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FullPageLoader from "./FullPageLoader";
import { useUserContext } from "../contexts/userContext";

const UserLoadingGate = ({ isAuthenticated, children }) => {
  const { isLoading, error, user } = useUserContext();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !isLoading) {
      setTimedOut(false);
      return undefined;
    }
    const timer = setTimeout(() => setTimedOut(true), 15000);
    return () => clearTimeout(timer);
  }, [isAuthenticated, isLoading]);

  // If authenticated but user data failed to load and there's an error, redirect to login
  // Note: useApi already handles 401/403 redirects, so we only need to handle edge cases here
  useEffect(() => {
    // Only redirect if we're sure it's an auth error and not just a loading state
    // Don't redirect if still loading or if useApi already handled the redirect
    if (isAuthenticated && !isLoading && error && !user) {
      const errorMessage = error?.toLowerCase() || "";
      // Check if error is related to authentication
      // But only redirect if token still exists (useApi would have cleared it if it redirected)
      const token = localStorage.getItem("userId");
      if (token && (errorMessage.includes("401") || 
          errorMessage.includes("403") || 
          errorMessage.includes("unauthorized") || 
          errorMessage.includes("forbidden") ||
          errorMessage.includes("expired") ||
          errorMessage.includes("session expired"))) {
        // Clear token and redirect to login
        localStorage.removeItem("userId");
        window.location.href = "/login";
      }
    }
  }, [isAuthenticated, isLoading, error, user]);

  if (isAuthenticated && isLoading && !error && !timedOut) {
    return <FullPageLoader />;
  }

  return <>{children}</>;
};

UserLoadingGate.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default UserLoadingGate;
